// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useState, CSSProperties } from 'react';

interface IconProps {
  icon: string;
  hoverIcon?: string;
  style?: CSSProperties;
}

export default function ({ icon, hoverIcon, style, ...props }: IconProps & React.ComponentProps<'img'>) {
  const [src, setSrc] = useState(icon);

  function handleMouseLeave() {
    setSrc(icon);
  }

  function handleMouseEnter() {
    hoverIcon && setSrc(hoverIcon);
  }

  return (
    <img src={src} onMouseLeave={handleMouseLeave} onMouseEnter={handleMouseEnter} alt="" style={style} {...props} />
  )
}
